module.exports = {"230183100":"尚志镇","230183101":"一面坡镇","230183102":"苇河镇","230183103":"亚布力镇","230183104":"帽儿山镇","230183105":"亮河镇","230183106":"庆阳镇","230183107":"石头河子镇","230183108":"元宝镇","230183109":"黑龙宫镇","230183202":"长寿乡","230183204":"乌吉密乡","230183206":"鱼池乡","230183207":"珍珠山乡","230183208":"老街基乡","230183209":"马延乡","230183211":"河东乡","230183400":"苇河林业局","230183401":"亚布力林业局","230183402":"哈尔滨市政府亚布力滑雪旅游度假区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230183.json
// module id = 777
// module chunks = 0